module.exports = __webpack_public_path__ + "static/media/80-20.8d3a0088.jpg";